<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100 pl-24 pr-24 pb-24 pt-16">
    @if (showBreadcrumbs) {
        <ui-kit-breadcrumbs #breadcrumbs
                            [filterOneLevelNavigation]="filterOneLevelNavigation"
                            [customLastBreadcrumb]="customLastBreadcrumb"
                            [filterNavigationPath]="filterNavigationPath"
                            [navigateBackListener]="navigateBackListener"
                            [customNavigation]="customNavigateToPath"
                            [queryParamsHandling]="queryParamsHandling"
                            [rootPath]="rootPath"
                            [tabPathToTab]="tabPathToTab"
                            [specialFilter]="specialFilter"
                            [breadcrumbCustomizer]="breadcrumbCustomizer"
                            [prefixPaths]="prefixPaths">
        </ui-kit-breadcrumbs>
    }
    @if (!(spinnerIds && spinnerIsShown)) {
        <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="w-100 min-title-height"
            [class.mt-8]="showBreadcrumbs"
            [class.mt-24]="!showBreadcrumbs && title">
            @if (title || showBackButton) {
                <div fxLayout="row" fxLayoutAlign="start center" class="w-100">
                    @if (showBackButton) {
                        <ui-kit-svg
                            class="i-24 pointer"
                            name="ic_arrow_back"
                            (click)="breadcrumbs.navigateBack()">
                        </ui-kit-svg>
                    }
                    @if (title) {
                        <div class="h3-semi-bold"
                             [class.ml-16]="showBackButton">
                            {{ title }}
                        </div>
                    }
                    <ng-content select="[CustomTitle]"></ng-content>
                </div>
            }
            <ng-content select="[CustomButtons]"></ng-content>
            @if (buttonLabel) {
                <ui-kit-button
                    [type]="buttonType"
                    [color]="buttonColor"
                    fxHide.mobile
                    [matTooltip]="buttonDisabled ? (buttonDisabledTooltip | translate) : null"
                    [disabled]="buttonDisabled"
                    [spinnerId]="buttonSpinnerId"
                    [label]="buttonLabel"
                    (clickListener)="buttonClickListener.emit()">
                </ui-kit-button>
            }
        </div>
    }
    <div fxLayout="column" fxLayoutAlign="start start" class="content-wrapper h-100 w-100 hide-scroll-bar"
         [style.overflow-y]="enableScroll ? 'auto' : 'hidden'">
        @if (spinnerIds && spinnerIsShown && !isInDevelopment) {
            <div class="h-100 w-100" fxLayout="column"
                 fxLayoutAlign="center center">
                <ui-kit-spinner [spinnerIds]="spinnerIds"></ui-kit-spinner>
            </div>
        }
        @if (!(spinnerIds && spinnerIsShown && !isInDevelopment)) {
            <ng-content></ng-content>
        }
        @if (isInDevelopment) {
            <ui-kit-empty-state backgroundColor="light"
                                class="mt-24 w-100"
                                [title]="'i18n_af_emptyStateTitleInProgress'"
                                subtitle="i18n_af_emptyStateSubtitleInProgress"
                                icon="ic_in_progress"/>
        }
    </div>
</div>
